import {
  DEFAULT_PIN_SVG,
  SELECTED_PIN_SVG,
} from './useRetailStoresMap.constants';

export const createMarkerContent = (isSelected: boolean) => {
  const container = document.createElement('div');

  container.innerHTML = isSelected ? SELECTED_PIN_SVG : DEFAULT_PIN_SVG;

  if (isSelected) {
    const border = document.createElement('div');

    border.style.position = 'absolute';
    border.style.width = '56px';
    border.style.height = '56px';
    border.style.border = '3px solid #4285F4';
    border.style.borderRadius = '50%';
    border.style.top = '-12px';
    border.style.left = '-12px';
    border.style.animation = 'pulse 2s infinite';

    const style = document.createElement('style');

    style.textContent = `
        @keyframes pulse {
          0% { transform: scale(0.8); opacity: 1; }
          70% { transform: scale(1.0); opacity: 0.7; }
          100% { transform: scale(0.8); opacity: 1; }
        }
      `;

    container.appendChild(style);
    container.appendChild(border);
  }

  return container;
};
